import React from 'react'

import {Button} from '@vio/atlas/Button'
import {Icon} from '@vio/atlas/Icon'

import {useIsSaveFraming} from '../../hooks/useIsSaveFraming'

type PriceWatchBellProps = {
  isToggleOn: boolean
  handleClick: (event: React.SyntheticEvent<Element, Event>) => void
  BottomSheet?: () => JSX.Element | null
}

export const PriceWatchBell = ({
  isToggleOn,
  handleClick
}: PriceWatchBellProps) => {
  const saveFramingIsOn = useIsSaveFraming()
  const [onIcon, offIcon] = saveFramingIsOn
    ? (['HeartFilled', 'Heart'] as const)
    : (['BellCheck', 'Bell'] as const)
  // Design fills the saved heart red on the card surfaces (307-24622,
  // semantic/content/danger/secondary). Control keeps the bell's inherited
  // colour.
  const savedHeartColorPath =
    saveFramingIsOn && isToggleOn ? 'content.danger.secondary' : undefined

  // Native listeners on ancestors must not fire either. handleClick only stops
  // the React propagation.
  const onClick = (event: React.SyntheticEvent<Element, Event>) => {
    event.nativeEvent.stopImmediatePropagation()
    handleClick(event)
  }

  return (
    <Button
      variant="tertiary"
      size="md"
      isRounded
      dataId={isToggleOn ? 'PriceWatchBellOn' : 'PriceWatchBell'}
      ariaPressed={isToggleOn}
      onClick={onClick}
      iconStart={
        <Icon
          name={isToggleOn ? onIcon : offIcon}
          size="md"
          colorPath={savedHeartColorPath}
        />
      }
    />
  )
}
